import React, { useContext } from 'react';
import { DEFAULT_MARKETPLACE_FEATURE_FLAGS } from './MarketplaceFeatureFlags';
const FeatureFlagsContext = /*#__PURE__*/React.createContext(DEFAULT_MARKETPLACE_FEATURE_FLAGS);
export const FeatureFlagsProvider = FeatureFlagsContext.Provider;

/**
 * Get feature flags from context.
 *
 * NOTE:- The flag name/key from LaunchDarkly will be transformed using lodash camelCase
 * utility, if you do not see your flag value being populated correctly, cross-check if the
 * camelCase-ed name is used.
 */
export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}